// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoPanel_video-container__kuvFb","item-centered":"VideoPanel_item-centered___2Gsw"};